// extracted by mini-css-extract-plugin
export var card = "_52-0";
export var content = "_52-1";
export var contentLoading = "_52-2";